"use client";

import React from "react";
import { useActiveTenant } from "tenants/TenantProvider";
import clsx from "clsx";
import SanityImage from "./SanityImage";

export const TenantLogo = ({ className, ...props }: { className?: string }) => {
	const tenant = useActiveTenant();

	if (!tenant.theme.logoReversed) {
		return null;
	}

	return (
		<div className="w-[160px] h-[40px] lg:h-[60px] relative">
			<SanityImage
				image={tenant.theme.logoReversed}
				width={140}
				height={70}
				isFluid
				className={clsx(
					className,
					"w-full h-full object-contain object-left absolute top-0 left-0",
				)}
				{...props}
			/>
		</div>
	);
};
